export default {
  headline: 'Edytuj użytkownika',
  permissions: 'Uprawnienia',
  controllerUserMapping: 'Mapowanie użytkowników kontrolera',
  role: 'Role',
  customPermission: 'Uprawnienia niestandardowe',
  appPermission: 'Uprawnienia aplikacji',
  assetPermission: 'Uprawnienia do zasobów',
  firstName: 'Imię',
  lastName: 'Nazwisko',
  email: 'E-mail',
  warningHeadline: 'Tracisz dostęp do Zarządzania użytkownikami',
  warningText: 'Zaraz zablokujesz sobie dostęp do Zarządzania użytkownikami. Możesz odzyskać dostęp tylko wtedy, gdy inny administrator przyzna Ci go ponownie',
};
